import { InjectionToken } from '@angular/core';
import { OAuth2Token } from '@maximizer/core/shared/domain';

/**
 * Bridge to a peer browser context that owns the real refresh token.
 * A browser-only popup has no refresh token of its own, so it obtains fresh
 * tokens from a peer (its opener) instead of refreshing over HTTP.
 */
export interface OAuth2PeerTokenBridge {
  /** Ask a peer for a fresh token; resolves null if no peer can supply one. */
  tryGetTokenFromPeer(
    currentRefreshTokenHash: string,
  ): Promise<OAuth2Token | null>;
  /** Tell peers this context just rotated the token so they can adopt it. */
  broadcastTokenToPeers(token: OAuth2Token): void;
}

export const OAUTH2_PEER_TOKEN_BRIDGE =
  new InjectionToken<OAuth2PeerTokenBridge>('OAuth2PeerTokenBridge');
